exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".DocumentDashboardPanel-defaultContent-jD-YL{position:relative;height:100%}.DocumentDashboardPanel-defaultContent-jD-YL h4{color:#8a959a}.DocumentDashboardPanel-defaultContent-jD-YL h4 i{margin-right:5px}.DocumentDashboardPanel-defaultContent-jD-YL b{display:inline-block;width:24px;height:24px;font-size:20px;line-height:1;text-align:center}.DocumentDashboardPanel-documentGroup-2L154 ul{margin:0;padding:0;list-style-type:none}.DocumentDashboardPanel-documentGroup-2L154 ul>li{display:block;padding:2px 0}.DocumentDashboardPanel-documentGroup-2L154 ul>li.DocumentDashboardPanel-ok-3xcwP a{color:#00e5ce}.DocumentDashboardPanel-documentGroup-2L154 ul>li.DocumentDashboardPanel-documentExpiredInLessThan15Days-1kvGp a{color:#faad44}.DocumentDashboardPanel-documentGroup-2L154 ul>li.DocumentDashboardPanel-documentExpired-15VTr a{color:#ff5766}.DocumentDashboardPanel-documentGroup-2L154 small{font-size:16px;color:#b0bec5}.DocumentDashboardPanel-logo-2cVj_{position:absolute;bottom:10px;right:0}", ""]);

// exports
exports.locals = {
	"defaultContent": "DocumentDashboardPanel-defaultContent-jD-YL",
	"documentGroup": "DocumentDashboardPanel-documentGroup-2L154",
	"ok": "DocumentDashboardPanel-ok-3xcwP",
	"documentExpiredInLessThan15Days": "DocumentDashboardPanel-documentExpiredInLessThan15Days-1kvGp",
	"documentExpired": "DocumentDashboardPanel-documentExpired-15VTr",
	"logo": "DocumentDashboardPanel-logo-2cVj_"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[name]-[local]-[hash:base64:5]!./~/autoprefixer-loader!./~/less-loader!./lib/actradis/components/DocumentDashboardPanel.less
// module id = 1596
// module chunks = 0